import api from '@/modules/api'

export default class OrderService{
  public async paymentResult(orderId: string): Promise<any> {
    return api.get(`Order/Payment/${orderId}`)
  }
}
